import Router from "next/router";
import { useEffect, useState } from "react";

export default function useReplyContour(replyShortId: string, timeMs = 6000) {
  const [hasContour, setHasContour] = useState(false);

  useEffect(() => {
    const scheduledTimeout = setTimeout(() => {
      if (hasContour) {
        setHasContour(false);
      }
    }, timeMs);

    return () => {
      clearTimeout(scheduledTimeout);
    };
  }, [hasContour, timeMs]);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    if (window.location) {
      const hash = (window.location.hash || "").slice(1);
      setHasContour(hash === replyShortId);
    }
  }, [replyShortId]);

  useEffect(() => {
    const hashChange = () => {
      if (window.location) {
        const hash = (window.location.hash || "").slice(1);
        setHasContour(hash === replyShortId);
      }
    };

    Router.events.on("hashChangeComplete", hashChange);

    return () => {
      Router.events.off("hashChangeComplete", hashChange);
    };
  }, [replyShortId]);

  return hasContour;
}
